require('./modal.js');

Pegasus.DefaultListModal = Pegasus.Modal.extend({
  title: function(){
    return Em.I18n.t('instructions.update_required_fields');
  }.property(),
  width: '600px',

  classNames: ['vr-select-default-list'],

  submitDisabled: false,
  cancelEnabled: false,
  hasFooter: true,

  selectedList: null,

  saveNewList: function(){
    this.get('controller').send('saveNewContactList', this.get('newListName') );
    this.set('newListName', '');
  },

  didChangeSelectedList: function(){
    if ( this.get('selectedList') ) {
      this.set('errors', {});
    }
  }.observes('selectedList'),

  didAddSelectableList: function(){
    this.set('controller.defaultListId', this.get('controller.selectableContactLists.lastObject.id') );
    Em.run.scheduleOnce('afterRender', this.get('controller'), 'send', 'saveAndContinue');
  }.observes('controller.selectableContactLists.length'),

  didChangeNewListName: function(){
    var controller = this.get('controller'),
      newName = this.get('newListName'),
      existingNames = controller.get('selectableContactLists').mapProperty('name');

    if ( !newName ) {
      this.set('errors', {
        newListName: [ Em.I18n.t('g.invalid_list_name') ]
      });
      return;
    }

    if ( newName.length > 140 ) {
      this.set('errors', {
        newListName: [ Em.I18n.t('g.list_name_too_long') ]
      });
      return;
    }

    existingNames = existingNames.map(function(item){
      return item.toLowerCase();
    });

    if ( existingNames.contains( newName.trim().toLowerCase() ) ) {
      this.set('errors', {
        newListName: [ Em.I18n.t('g.list_name_exists') ]
      });
    } else {
      this.set('errors', {});
    }
  }.observes('newListName'),

  newListName: '',

  bodyTemplateName: 'modals/default_list',

  headerClassName: 'editor-modal-header',
  bodyClassName: 'editor-modal-body',
  footerClassName: 'editor-modal-footer',

  newListTextField: Pegasus.TextField.extend({
    classNames: ['newListName'],
    fieldName: null,
    errors: null,
    value: null,
    placeholder: function(){
      return Ember.I18n.t("g.forms_enter_new_list_name")
    }.property(),
    focusOut: function() {
      this._super();
      this.get('presenter').didChangeNewListName();
    }
  }),

  selectListView: Em.View.extend({
    classNames: ['vr-select-form-list'],
    templateName: 'modals/form/list_select'
  }),

  didSubmit: function(){
    if ( this.get('presenter.errors.newListName.length') ) {
      return;
    }
    if ( ! this.get('presenter.selectedList') && this.get('presenter.newListName') ) {
      this.get('presenter').saveNewList();
      this.get('controller').set('presenter', null);
      return;
    }
    this.set('presenter.controller.defaultListId', this.get('presenter.selectedList.id') );
    this.get('controller').set('presenter', null);
    this.get('controller').send('saveAndContinue');
  },

  didCancel: function(){
    this.set('presenter.errors', {});

    var presenter = this.get('controller.presenter');
    this.get('controller').set('presenter', null);
    if ( presenter ) {
      presenter.destroy();
    }
  }
});
